import { useEffect, useRef } from "react";

// Back-navigation for detail overlays (Round 13.1). Esc closes the overlay,
// and on close focus + view return to the element that opened it (the
// originating row) so the user lands back where they were — not at a
// blown-open page. The opener is captured ONCE on mount; onClose is read
// through a ref so an unstable callback identity never re-runs the effect.
export function useModalDismiss(onClose: () => void): void {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const opener = document.activeElement as HTMLElement | null;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeRef.current();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      if (opener && document.contains(opener)) {
        opener.focus({ preventScroll: true });
        opener.scrollIntoView({ block: "nearest" });
      }
    };
  }, []);
}
